<template>
    <div style="background:#78143a">
        <div style="width:1400px; margin:0 auto; padding:10px 0; color:#fff;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}" style="color:#fff">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="l12install_ctrl">
            <section class="data">
                <h2 class="l12install_title">{{ name }}</h2>
                <div style="text-align:center; color:#fff; margin:20px 0 30px 0 ">
                    选择查询日期：
                    <a-date-picker  placeholder="选择查询日期" v-model="selectdate" :allowClear="false"/>
                </div>
                <div class="l12install_process">
                <div class="l12install_cell cell-arrow" data-desc="初始化成功">
                    {{ data.Activation }}
                    <div class="arrow">{{ data.Activation2LoginUI }}<span v-if="data.Activation2LoginUI">%</span></div>
                </div>
                <div class="l12install_cell cell-arrow" data-desc="到达登录界面">
                    {{ data.LoginUI }}
                    <div class="arrow">{{ data.LoginUI2Identification }}<span v-if="data.LoginUI2Identification">%</span></div>
                </div>
                <div class="l12install_cell cell-arrow" data-desc="完成账号认证">
                    {{ data.Identification }}
                    <div class="arrow">{{ data.Identification2Load }}<span v-if="data.Identification2Load">%</span></div>
                </div>
                <div class="l12install_cell cell-arrow" data-desc="到达游戏界面">
                    {{ data.Load }}
                    <div class="arrow">{{ data.Load2CreateRole }}<span v-if="data.Load2CreateRole">%</span></div>
                </div>
                <div class="l12install_cell cell-gray" data-desc="登录老角色">
                    暂未开放
                </div>
                <div class="l12install_cell cell-reverse" data-desc="补丁更新">
                    {{ data.Update }}
                    <div class="arrow arrow-top">{{ data.Activation2Update }}<span v-if="data.Activation2Update">%</span></div>
                    <div class="nextlogin"></div>
                </div>
                <div class="l12install_cell cell-arrow cell-reverse cell-gray cell-offset2" data-desc="创建新角色">
                    暂未开放
                    <div class="arrow"></div>
                    <div class="arrow arrow-top"></div>
                </div>
                <div class="l12install_cell cell-reverse cell-gray" data-desc="登录新角色">
                    暂未开放
                </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import moment from "moment"
import {DatePicker, Input} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(DatePicker)
Vue.use(Input)

import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'

export default {
    mixins: [ctrlMixin],
    name:'l12install',
    props: ['parent', 'name'],
    components: {
        DataTable,
        Chart,
    },
    mounted(){
        this.selectdate = moment().subtract(1,'day')
        this.getData()
    },
    watch: {
        selectdate(newV) {
            this.getData()
        }
    },
    data() {
        return {
            selectdate: null,
            data: {
            },
        }
    },
    methods: {
        getData() {
            this.loading = true
            this.$service.query(this.queryId, {selectdate:this.selectdate.format('YYYY-MM-DD')}).then((data)=>{
                this.data = data
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less" scoped>
@width:1500px;

@cellWidth: 120px;
@arrowWidth: @cellWidth / 6;
@arrowColor: #a2a2a2;
@mainColor: #78143a;

.light(@color) {
  background-color: @color;
  border: 2px solid darken(@color, 10%);
  box-shadow: 1px 1px 3px darken(@color, 10%);
}

.l12install_ctrl {
  background-color: #151a40;
  height: 700px;
  padding:60px 40px;
  overflow: hidden;
  
    .l12install_title {
    margin-bottom: 30px;
    font-size: 30px;
    color: #fff;
    text-align: center;
    }

    .l12install_process {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    width: @cellWidth * 7;
    margin-left: auto;
    margin-right: auto;
    }
    .l12install_cell {
    position: relative;
    margin-top: @cellWidth / 2;
    width: @cellWidth;
    height: @cellWidth;
    line-height: @cellWidth;
    text-align: center;
    .light(@mainColor);
    border-radius: 50%;
    font-size: 20px;
    color: #fff;
    &:after {
        content: attr(data-desc);
        position: absolute;
        top: @cellWidth / -6;
        left: 0;
        width: 100%;
        text-align: center;
        line-height: 1;
        font-size: 14px;
        font-weight: 600;
        color: #ccc;
    }
    &.cell-gray {
        .light(@arrowColor);
        color: #ccc;
    }
    &.cell-offset2 {
        margin-left: @cellWidth * 3.5;
    }
    &.cell-reverse {
        &:after {
        top: auto;
        bottom: @cellWidth / -6;
        }
    }
    &.cell-arrow {
        margin-right: @cellWidth / 2;
        .arrow {
        position: absolute;
        right: @cellWidth / -2;
        bottom: 0;
        }
    }
    .nextlogin {
        position: absolute;
        height: @arrowWidth;
        width: @cellWidth * 0.7;
        left: @cellWidth / 2;
        top: @cellWidth / 2 - @arrowWidth / 2;
        background-color: @arrowColor;
        transform: rotate(-45deg) translate(@cellWidth * 0.7, @arrowWidth);
        transform-origin: left;
        &:after {
        content: "";
        position: absolute;
        border: @arrowWidth * 0.9  solid transparent;
        border-left-color: @arrowColor;
        top: 50%;
        margin-top: 0 - @arrowWidth * 0.9;
        left: @cellWidth * 0.7 - 1;
        }
    }
    }
    .arrow {
    position: relative;
    width: @cellWidth / 2;
    height: @cellWidth;
    text-align: center;
    padding-top: @arrowWidth;
    color: #ccc;
    line-height: 1;
    font-size: 14px;
    &:before,
    &:after {
        content: "";
        position: absolute;
    }
    &:before {
        bottom: (@cellWidth - @arrowWidth) / 2;
        left: @arrowWidth / 2;
        width: @arrowWidth;
        height: @arrowWidth;
        background-color: @arrowColor;
    }
    &:after {
        bottom: @cellWidth / 2 - @arrowWidth * 0.9;
        left: @arrowWidth * 1.5;
        border: @arrowWidth * 0.9  solid transparent;
        border-left-color: @arrowColor;
    }
    &.arrow-top {
        position: absolute;
        top: 0 - @cellWidth / 2;
        left: 0;
        transform: rotate(90deg);
        transform-origin: right center;
    }
    }
}

</style>